import Card from 'components/card';
import { MdClose, MdCheckCircle } from 'react-icons/md';
import { useEffect, useState } from 'react';
import { InlineWidget } from 'react-calendly';

const WelcomeModal = (props: { isOpen: boolean; onClose: () => void; onSignUp: () => void }) => {
    const { isOpen, onClose, onSignUp } = props;
    const [showIframe, setShowIframe] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setShowIframe(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity">
            <div className="relative z-[1002] w-full max-w-[700px] p-4 max-h-[90vh] flex flex-col">
                <Card extra="px-6 pt-6 pb-6 w-full flex flex-col !z-[1004] border shadow-2xl overflow-y-auto">
                    <div className="absolute right-3 top-3 z-10">
                        <MdClose
                            size={16}
                            className="cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
                            onClick={onClose}
                        />
                    </div>

                    {!showIframe ? (
                        <>
                            {/* Header Section with Gradient */}
                            <div className="rounded-[20px] border border-gray-200/50 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-6 mb-6 shadow-lg dark:border-white/10 dark:from-navy-800 dark:to-navy-900">
                                <div className="text-center">
                                    <h2 className="mb-4 text-[28px] font-bold leading-tight text-gray-900 dark:text-white">
                                        Chez nous, les prix ne s'affichent pas. Ils se définissent.
                                    </h2>
                                    <div className="text-left space-y-4 text-base leading-relaxed text-gray-600 dark:text-gray-400">
                                        <p>
                                            Leadrs n'est pas un catalogue de leads avec des tarifs imposés.
                                            C'est une marketplace intelligente où vous décidez du prix que vous êtes prêt à payer, selon votre rentabilité et votre stratégie.
                                        </p>
                                        <p>
                                            Nos algorithmes de matching attribuent les leads en fonction de votre positionnement, de votre scoring et de votre prix cible.
                                        </p>
                                        <p className="font-semibold text-gray-700 dark:text-gray-300">
                                            Vous voulez voir comment ça fonctionne ?
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* CTA Buttons */}
                            <div className="space-y-3">
                                <button
                                    onClick={onSignUp}
                                    className="w-full bg-leadrs hover:bg-leadrs/90 text-white font-bold py-4 px-6 rounded-xl transition duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                                >
                                    Créer mon compte
                                </button>
                                <button
                                    onClick={() => setShowIframe(true)}
                                    className="w-full bg-white hover:bg-gray-50 text-leadrs border-2 border-leadrs font-bold py-4 px-6 rounded-xl transition duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                                >
                                    Prendre rendez-vous avec un expert Leadrs
                                </button>
                            </div>

                            {/* Skip Button */}
                            <div className="text-center mt-4">
                                <button
                                    onClick={onClose}
                                    className="text-sm font-medium text-gray-600 hover:text-leadrs transition duration-200 dark:text-gray-400 dark:hover:text-leadrs"
                                >
                                    Je découvre la plateforme
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* Calendly Section */}
                            <div className="mb-4 mt-6">
                                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2 text-center">
                                    Planifiez un appel avec notre équipe
                                </h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 text-center">
                                    Discutons de vos besoins et découvrez comment Leadrs peut vous aider à générer plus de business.
                                </p>

                                {/* Calendly Embed */}
                                <div className="rounded-[20px] overflow-hidden border border-gray-200 dark:border-white/10">
                                    <InlineWidget 
                                        url="https://calendly.com/lewis-weareleadrs/30min"
                                        styles={{ height: '700px', minWidth: '320px' }}
                                    />
                                </div>
                                </div>

                            {/* Back Button */}
                            <div className="text-center mt-4">
                                <button
                                    onClick={() => setShowIframe(false)}
                                    className="text-sm font-medium text-gray-600 hover:text-leadrs transition duration-200 dark:text-gray-400 dark:hover:text-leadrs"
                                >
                                    Retour
                                </button>
                            </div>
                        </>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default WelcomeModal;
